import { render } from "./test-tube-icon.svg?vue&type=template&id=7a20db06"
import script from "./test-tube-icon.svg?vue&type=script&lang=js"
export * from "./test-tube-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1360/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__